import React from 'react';

/** 方眼レイヤ（主線 = クロスヘア列 10%、補助線 = 8 等分 5%）。黒面（data-theme-mid="dark"）のみ表示 */
export default function GridLayer() {
  return <div className="bp-grid" aria-hidden="true" />;
}
